import React from 'react';

/**
 * Error boundary to catch crashes in the chat widget
 * Prevents the entire widget from breaking if a component crashes
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Chat widget error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="chat-error" style={{ marginBottom: 0 }}>
          <span>
            <strong>Oops!</strong> Something went wrong with the chat widget.{' '}
            <button
              onClick={() => this.setState({ hasError: false })}
              style={{
                background: 'none',
                border: 'none',
                color: 'var(--forest)',
                textDecoration: 'underline',
                cursor: 'pointer',
                padding: 0,
              }}
            >
              Try again
            </button>
          </span>
        </div>
      );
    }

    return this.props.children;
  }
}
